import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import About from './views/About.vue'
import Login from './components/auth/Login.vue'
import EmailPasswordReset from './components/auth/EmailPasswordReset.vue'
import PasswordReset from './components/auth/PasswordReset.vue'
import Dashboard from './components/Dashboard.vue'
import NotFound from './components/404.vue'
import Validator from './components/Validator.vue'
import Rfid from './components/Rfid.vue'
import Uporabniki from './components/Uporabniki.vue'
import Uporabnik from './components/Uporabnik.vue'
import Test from './components/Test.vue'
import store from './store'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/email/password-reset',
      name: 'email-password-reset',
      component: EmailPasswordReset
    },
    {
      path: '/password-reset',
      name: 'password-reset',
      component: PasswordReset
    },
    {
      path: '/',
      component: Dashboard,
      children: [
        {
          path: 'validator',
          alias: '',
          component: Validator,
          name: 'validator',
          meta: { requiresAuth: true }
        },
        {
          path: 'dodaj-uporabnika',
          component: Rfid,
          name: 'rfid',
          meta: { requiresAuth: true },
          beforeEnter: (to, from, next) => {
            if(store.getters.permissions.includes('root') || store.getters.permissions.includes('rfid_uporabniki'))
            {
              return next()
            }

            next({ path: '/' })
            
          }
        },
        {
          path: 'uporabnik/:uuid',
          component: Uporabnik,
          name: 'uporabnik',
          meta: { requiresAuth: true },
          beforeEnter: (to, from, next) => {
            if(store.getters.permissions.includes('root') || store.getters.permissions.includes('rfid_uporabniki'))
            {
              return next()
            }

            next({ path: '/' })
            
          }
        },
        {
          path: 'seznam-uporabnikov',
          component: Uporabniki,
          name: 'seznam-uporabnikov',
          meta: { requiresAuth: true },
          beforeEnter: (to, from, next) => {
            if(store.getters.permissions.includes('root') || store.getters.permissions.includes('rfid_uporabniki'))
            {
              return next()
            }

            next({ path: '/' })
            
          }
        },
        {
          path: 'test',
          component: Test,
          name: 'test' 
        }
      ]
    },
    {
      path: '*',
      name: '404',
      component: NotFound
    }
    
  
  ]
})
